<template>
    <div id="buycard">
        <ul class="links">
            <li><router-link to='/user/buyCard/buyChangeCard'>申请买卡</router-link></li>
            <li><router-link to='/user/buyCard/buyChangeCardQuestion?disposeState=1' replace>待发货</router-link></li>
            <li><router-link to='/user/buyCard/buyChangeCardQuestion?disposeState=3' replace>已发货</router-link></li>
            <li><router-link to='/user/buyCard/buyChangeCardQuestion' replace>申请记录</router-link></li>
        </ul>
        <div class="view">
            <router-view/>
        </div>
    </div>
</template>
<script>
export default {
    methods: {
        
    },
    created(){
    }
}
</script>
<style lang="less">
#buycard {
    min-height: 100%;
    background: #f2f2f2;
    ul.links {
        position: fixed;
        top: 0;
        z-index: 999;
        width: 100%;
        display: flex;
        justify-content: space-around;
        background: #fff;
        li {
            width: 25%;
            line-height: 38px;
            text-align: center;
            a {
                display: inline-block;
                color: #838383;
                line-height: 28px;
                &.router-link-exact-active {
                    color: #2c3e50;
                    border-bottom: 2px solid #26a2ff;        
                }                 
            }                
        }
    }
    .view {
        height: calc(100% - 48px);
        margin-top: 38px;
        padding-bottom: 10px;
    }
}
</style>

